// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { chartDiagramParentFocus16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-chart-diagram-parent-focus': IconChartDiagramParentFocus;
    }
}

/**
 * The icon component for the 'chartDiagramParentFocus' icon
 */
export class IconChartDiagramParentFocus extends IconSvg {
    public constructor() {
        super(chartDiagramParentFocus16X16);
    }
}

registerIconSvg('icon-chart-diagram-parent-focus', IconChartDiagramParentFocus);
export const iconChartDiagramParentFocusTag = 'nimble-icon-chart-diagram-parent-focus';
